import { useQuery } from "@apollo/client";

import { useShouldShowSubscriptionOverhaul } from "MVVM/Hooks/useSubscriptionOverhaul";
import { useUser } from "MVVM/Hooks/useUser";
import { GET_USER_CLIP_COUNT } from "MVVM/GraphQL/user";
import { CLIP_STORAGE_STATUS } from "MVVM/GraphQL/savedClipStatus";

export const useUnsavedDraftCount = (): number | null => {
  const showSubscriptionOverhaul = useShouldShowSubscriptionOverhaul();
  const { allstarUser } = useUser();

  const username = allstarUser?.user?.profile?.username;
  const loggedIn = allstarUser?.loggedIn;

  const { data: clipCountData } = useQuery(GET_USER_CLIP_COUNT, {
    variables: { query: username, status: "READY" },
    skip: !username || !showSubscriptionOverhaul,
    fetchPolicy: "cache-first",
  });

  const { data: storageData } = useQuery(CLIP_STORAGE_STATUS, {
    skip: !loggedIn || !showSubscriptionOverhaul,
    fetchPolicy: "cache-first",
  });

  const clipCount: number | null = clipCountData?.profile?.clipCount ?? null;
  const storageStatus = storageData?.me?.clipStorageStatus;

  if (!showSubscriptionOverhaul || !storageStatus || clipCount === null) {
    return null;
  }

  const unsavedCount =
    clipCount -
    (storageStatus.savedCount ?? 0) -
    (storageStatus.protectedClipCount ?? 0);

  return unsavedCount > 0 ? unsavedCount : null;
};
